import { Target, TargetType } from 'stores/workflowStores/finances/targets/model';
import { Deposit, DepositType } from 'stores/workflowStores/finances/depositsStore/model';
import { Reserve } from 'stores/workflowStores/finances/newReservesStore/model';
import { Currency, PersonType } from 'enums';
import { RentData } from 'stores/workflowStores/finances/rent/model';
import { ExtProductUsage } from 'pages/Accounts/Edit/components/ExternalProducts/model';

export interface ExtTarget extends Target {
  date?: string;
}
export interface ExtDeposit extends Deposit {
  date?: string;
}
export interface ExtReserve extends Reserve {
  date?: string;
}

export enum EventType {
  TARGET = 'TARGET',
  DEPOSIT = 'DEPOSIT',
  PERIODIC_DEPOSIT = 'PERIODIC_DEPOSIT',
  WITHDRAWAL = 'WITHDRAWAL',
  RESERVE = 'RESERVE',
  DATE = 'DATE',
  PROPERTY = 'PROPERTY',
  LOAN = 'LOAN',
}

export enum DepositBySubtype {
  CASH_DEPOSIT = 'CASH_DEPOSIT',
  EMPLOYER_DEPOSIT = 'EMPLOYER_DEPOSIT',
}

export interface EventLabelProps {
  id: string;
  currency: Currency;
  type?: EventType;
  extProduct?: boolean;
  iconType: TargetType | DepositType | 'RESERVE_END' | 'DATE';
  icon?: string;
  color?: string;
  title?: string;
  targetTitle?: string;
  value?: { value: number };
  inflation?: { rate: number };
  inflatedValue?: number;
  since?: string;
  date?: string;
  until?: string;
  horizon?: string;
  bucket?: string;
  align?: string;
  pos?: number;
  repeat?: boolean;
  repeatYears?: string;
  frequency?: string;
  rent?: boolean;
  rentData?: RentData;
  readOnly?: boolean;
  personType?: PersonType;
  size: number;
  pdf?: boolean;
  altColors?: boolean;
  totalAtPos?: number;
  historical?: boolean;
  subtype?: DepositBySubtype;
  usage?: ExtProductUsage;
  failedDeposit?: boolean;
}
